<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
                v-for="(route, index) in breadcrumbs"
                :key="index"
                :to="{ path: route.path }"
            >
                {{ route.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>

        <el-row></el-row>
    </div>
</template>

<script>
    /* eslint-disable no-console,no-restricted-syntax,no-continue,no-loop-func,array-callback-return,consistent-return,prefer-const */

    export default {
        name: 'Breadcrumb',
        data () {
            return {
                breadcrumbs: [],
            };
        },
        mounted () {
            const currentRoute = this.$router.currentRoute;
            const splitted = currentRoute.fullPath.split('/');
            if (splitted.length > 2) {
                this.addRoutes(splitted);
            }
        },
        methods: {
            addRoutes (splitted) {
                let flag = '';
                for (let one of splitted) {
                    if (one && one.length > 0) {
                        let route = this.$router.match(flag += `/${one}`);
                        if (route.matched.length > 0 && route.name !== 'not-found') {
                            this.breadcrumbs.push(route);
                        }
                    }
                }
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/atoms/breadcrumb/Breadcrumb.vue